<template>
  <CosFixFooterPage :autoFooter="selectData.target !== 'dayOffSetting'">
    <div class="rule-manage-box">
      <div class="title">{{ selectData.title }}</div>
      <div v-if="selectData.target === 'saleCue'" class="main-box">
        <p>
          每个用户，每天最多领取<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_1[0]"
            placeholder="请输入"
          />条销售线索。
        </p>
        <div class="subTitle">待跟进的有效线索</div>
        <p>
          自领取之日起，第一次跟进必须在<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[0]"
            placeholder="请输入"
          />个工作日内，之后每<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[1]"
            placeholder="请输入"
          />个工作日跟进<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[2]"
            placeholder="请输入"
          />次，
        </p>
        <p>
          连续<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[3]"
            placeholder="请输入"
          />次跟进期要求未达标，则自动退回公海池; 退回前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[4]"
            placeholder="请输入"
          />工作日，通过第三方（飞书）、系统弹窗提醒客户负责人跟进。
        </p>
        <div class="subTitle">未来线索</div>
        <p>
          联系时间到期前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_3[0]"
            placeholder="请输入"
          />个工作日的跟进记录小于<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_3[1]"
            placeholder="请输入"
          />条，通过第三方（飞书）、系统弹窗提醒客户负责人跟进。
        </p>
        <p>
          置为【未来线索】后，<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_3[2]"
            placeholder="请输入"
          />天后未变为有效线索，则自动进入公海池。
        </p>
        <div class="subTitle">无效线索</div>
        <p>
          置为【无效线索】后，<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_4[0]"
            placeholder="请输入"
          />天后未变为有效线索，则自动进入公海池。
        </p>
      </div>
      <div v-if="selectData.target === 'potentialCustomer'" class="main-box">
        <div class="subTitle">谈判</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_1[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_1[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">搁置</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_2[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_2[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
      </div>
      <div v-if="selectData.target === 'signCustomer'" class="main-box">
        <div class="subTitle">对接中</div>

        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGNING_RULE_1[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGNING_RULE_1[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">暂停合作</div>

        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGNING_RULE_2[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGNING_RULE_2[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
      </div>
      <div v-if="selectData.target === 'successCustomer'" class="main-box">
        <div class="subTitle">一档</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_1[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_1[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">二档</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_2[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_2[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">三档</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_3[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_3[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">四档</div>
        <p>
          距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_4[0]"
            placeholder="请输入"
          />个工作日内需要再次跟进，提前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_4[1]"
            placeholder="请输入"
          />个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
      </div>
      <div v-if="selectData.target === 'appSignSetting'" class="msg-box">
        <p>
          签到列表，展示自身定位<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_1[0]"
            placeholder="请输入"
          />米范围内的客户信息。（仅能在范围内签到）
        </p>
        <p>
          签到打卡后，在上次签到范围内<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_2[0]"
            placeholder="请输入"
          />分钟后才能第二次打卡签到；同一个客户<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_2[1]"
            placeholder="请输入"
          />分钟后才能第二次打卡签到。
        </p>
      </div>
    </div>
    <template #footer>
      <div class="footer-box" v-if="selectData.target !== 'dayOffSetting'">
        <a-button type="primary" @click="handleSubmit">保存</a-button>
      </div>
    </template>
    <div v-if="selectData.target === 'dayOffSetting'">
      <DayOffCalendar></DayOffCalendar>
    </div>
  </CosFixFooterPage>
</template>

<script lang="ts">
import { defineComponent, reactive, PropType, toRefs, onMounted } from 'vue'
import type { IndexEchart } from '@/types/index'
import DayOffCalendar from '@/components/DayOffCalendar/index.vue'
import { infoData, updateData } from '@/api/gucangSales/followRuleSetting'
import { DcMessage } from '@dc-platform/dc-components'
import CosFixFooterPage from '@/components/CosFullLayout/fixFooterPage.vue'

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<IndexEchart.RuleManageList>,
      default: () => ({})
    }
  },
  components: { DayOffCalendar, CosFixFooterPage },
  setup(props) {
    const selectData = toRefs(props).data
    const saleFormState = reactive<any>({
      CLUE_RULE_1: [0],
      CLUE_RULE_2: [0, 0, 0, 0, 0],
      CLUE_RULE_3: [0, 0, 0],
      CLUE_RULE_4: [0],
      DEAL_RULE_1: [0, 0, 0],
      DEAL_RULE_2: [0, 0, 0],
      DEAL_RULE_3: [0, 0, 0],
      DEAL_RULE_4: [0, 0, 0],
      POTENTIAL_RULE_1: [0, 0],
      POTENTIAL_RULE_2: [0, 0],
      SIGNING_RULE_1: [0, 0, 0],
      SIGNING_RULE_2: [0, 0, 0],
      SIGN_IN_RULE_1: [0],
      SIGN_IN_RULE_2: [0, 1]
    })
    const getData = async () => {
      try {
        const res = await infoData({ appId: 'cos_fbu', configType: 3 })
        const allData: any = res.data
        Reflect.ownKeys(allData).forEach(function (key) {
          saleFormState[key] = allData[key].split(',')
        })
        console.log('res: ', res)
      } catch (error) {
        console.log('error: ', error)
      }
    }
    const handleSubmit = async () => {
      try {
        const submitData: any = {}

        Reflect.ownKeys(saleFormState).forEach(function (key) {
          submitData[key] = saleFormState[key].join()
        })
        await updateData({
          appId: 'cos_fbu',
          logic: submitData
        })
        DcMessage.success('保存成功！')
        getData()
      } catch (error) {
        console.log('handleSubmit error: ', error)
      }
    }
    onMounted(() => {
      getData()
    })
    return {
      selectData,
      saleFormState,
      handleSubmit
    }
  }
})
</script>
<style lang="scss" scoped>
.rule-manage-box {
  padding: 16px 16px 0;
  .main-box {
    height: 65vh;
    // overflow-y: scroll;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }
  .input {
    width: 80px;
    display: inline-block;
    margin: 0 5px;
  }
  .subTitle {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    height: 40px;
    display: flex;
    align-items: center;
    margin: 25px 20px 16px;
    border-bottom: 1px solid rgb(235, 239, 241);
  }
  p {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .footer-box {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .line-bg {
    width: 100%;
    height: 8px;
    background-color: rgb(249, 249, 255);
    padding: 0 16px;
    box-sizing: content-box;
    position: relative;
    left: -16px;
  }
}
</style>
